import { useMutation } from 'react-query';
import { downloadRegisterResultPdfFile } from 'apis/registerResult.api';

const useDownloadRegisterResultPdfFile = () => useMutation(downloadRegisterResultPdfFile);

export default useDownloadRegisterResultPdfFile;
